export default {
  categories: [
    "All",
    "Industrial Rubber Parts",
    "Automotive Rubber Parts",
    "Packing & Gaskets",
    "Rubber Molded Products",
  ],
  items: [
    {
      id: "industrial-oring-001",
      name: "Industrial O-Ring",
      category: "Industrial Rubber Parts",
      subcategory: "O-Ring/Seal",
      application: "Pumps · Valves · Heat exchangers · Sealing devices",
      material: "NBR, EPDM, SILICONE, FKM",
      hardness: "70 ± 5 Shore A",
      tempRange: "-50℃ ~ +200℃",
      features: [
        "KS M 6518 compliant, dimensional tolerance within ±0.1mm",
        "Long service life with excellent heat and weather resistance",
        "Optimal material selection for each chemical and temperature environment",
        "Available from 100 units, tooling cost separate",
      ],
      description: "A core sealing component for industrial equipment such as pumps, valves, and heat exchangers. We offer NBR, EPDM, SILICONE, and FKM materials and supply the optimal O-ring for each application environment. Dimensional tolerances are strictly controlled through 50 years of precision molding expertise, with custom fabrication available for special specifications.",
      image: "https://public.readdy.ai/ai/img_res/edited_fedf7555450ccb7ed00b0b4fb8efc2ed_939bc09e.jpg",
      drawingAvailable: true,
    },
    {
      id: "industrial-diaphragm-002",
      name: "Industrial Diaphragm",
      category: "Industrial Rubber Parts",
      subcategory: "Diaphragm",
      application: "Chemical plants · Semiconductors · Pharmaceutical equipment · Pumps",
      material: "NBR, EPDM",
      hardness: "75 ± 5 Shore A",
      tempRange: "-20℃ ~ +250℃",
      features: [
        "Top-level weather resistance in extreme chemical environments",
        "Maintains elasticity even at 250℃ with excellent long-term durability",
        "Minimal outgassing in vacuum environments, ideal for semiconductor processes",
        "Custom shape design for replacing existing parts",
      ],
      description: "A diaphragm is a core component that controls pressure or fluid in pumps, valves, and regulators. With the excellent elasticity and weather resistance of NBR and EPDM, it delivers stable performance in fields requiring high reliability such as chemical plants and semiconductor and pharmaceutical equipment. Existing parts can be reverse-engineered from samples and perfectly reproduced.",
      image: "https://public.readdy.ai/ai/img_res/edited_d890bbcc9ea4eb0f6c7de6d54bb2116b_470c947f.jpg",
      drawingAvailable: true,
    },
    {
      id: "gasket-heat-ex-007",
      name: "Heat Exchanger Gasket",
      category: "Packing & Gaskets",
      subcategory: "Gasket",
      application: "Heat exchangers · Power plants · Chemical facilities",
      material: "EPDM, NBR",
      hardness: "70 ± 5 Shore A",
      tempRange: "-50℃ ~ +150℃",
      features: [
        "Precision gaskets dedicated to plate heat exchangers",
        "Excellent sealing performance in high temperature and pressure",
        "Compatible with Alfa Laval, GEA and other major manufacturers",
        "Food-grade (FDA) EPDM option available",
      ],
      description: "A high-performance gasket dedicated to plate heat exchangers (PHE), providing long-term stable sealing through the excellent heat and weather resistance of EPDM and NBR. It is precisely manufactured to the specifications of major heat exchanger manufacturers, with FDA-grade materials available for the food and pharmaceutical industries.",
      image: "https://public.readdy.ai/ai/img_res/edited_faa8145f0788d7e1d34e1eb094fcfaa4_4974e678.jpg",
      drawingAvailable: true,
    },
    {
      id: "auto-boots-004",
      name: "Automotive Rubber Boots / Bellows",
      category: "Automotive Rubber Parts",
      subcategory: "Boots/Bellows",
      application: "Automotive drivetrain · Steering · Suspension",
      material: "CR, NBR, EPDM",
      hardness: "60 ± 5 Shore A",
      tempRange: "-40℃ ~ +120℃",
      features: [
        "Produced under an IATF 16949 certified quality system",
        "Corrugated structure flexibly handles bending and reciprocating motion",
        "Long-term durability with excellent dust, water, and abrasion resistance",
        "Extensive supply record as Tier 1 supplier to Hyundai and Kia",
      ],
      description: "Rubber boots and bellows that block dust and debris and retain lubricant in automotive drivetrains, steering, and suspension. The corrugated structure provides excellent flexibility under bending motion, with CR, NBR, and EPDM materials offering both weather and abrasion resistance. Produced under strict quality control within the IATF 16949 certification system.",
      image: "https://public.readdy.ai/ai/img_res/edited_77aa2352dc62104b95f7338eb36bb29e_4696e11d.jpg",
      drawingAvailable: true,
    },
    {
      id: "silicone-valve-005",
      name: "Silicone Valve Seat / Ring",
      category: "Rubber Molded Products",
      subcategory: "Silicone Products",
      application: "Valves · Food machinery · Medical devices · Semiconductors",
      material: "VMQ (Silicone)",
      hardness: "50 ± 5 Shore A",
      tempRange: "-100℃ ~ +230℃",
      features: [
        "Biocompatible and food-grade (FDA)",
        "Free molding in transparent, translucent, and colored options",
        "Stable elasticity across a wide temperature range",
        "Precise dimensions through rubber molding technology",
      ],
      description: "Highly elastic silicone rubber products used in valves, food machinery, and medical devices. Featuring biocompatibility and a wide operating temperature range, they can be molded in transparent, translucent, and various colors. Supplied as valve seats and sealing rings, meeting strict quality standards for the food, pharmaceutical, and semiconductor industries.",
      image: "https://public.readdy.ai/ai/img_res/edited_2b5458d42347da3619363f71d295eb28_9b6d00e1.jpg",
      drawingAvailable: true,
    },
    {
      id: "precision-parts-006",
      name: "Precision Rubber Parts",
      category: "Rubber Molded Products",
      subcategory: "Precision Parts",
      application: "Electronics · Hard disk drives · Instruments · Sensors",
      material: "NBR, EPDM, VMQ",
      hardness: "40 ~ 70 Shore A",
      tempRange: "Varies by material",
      features: [
        "±0.05mm dimensional tolerance with micron-level precision molds",
        "Mass production of small and micro parts",
        "ISO 13485 medical device quality compliance",
        "Custom design and development based on customer drawings",
      ],
      description: "High-precision rubber parts used in electronics, hard disk drives, and instruments. Micron-level precision mold technology enables stable production of micro parts, with optimal material selection among NBR, EPDM, and silicone for electrical insulation, weather resistance, and heat resistance. Reverse engineering and custom fabrication are available from customer drawings and samples.",
      image: "https://public.readdy.ai/ai/img_res/edited_88b23a10800e108a671e0c3c7f9b1093_957f8309.jpg",
      drawingAvailable: true,
    },
    {
      id: "custom-diaphragm-008",
      name: "Custom Diaphragm",
      category: "Industrial Rubber Parts",
      subcategory: "Diaphragm",
      application: "Pumps · Valves · Hydraulic equipment · Chemical facilities",
      material: "NBR, EPDM, FKM, VMQ",
      hardness: "60 ~ 80 Shore A",
      tempRange: "-30℃ ~ +250℃",
      features: [
        "Perfect reverse-engineered fabrication from customer drawings/samples",
        "Optimized for each environment with various material and hardness options",
        "Wide range of sizes from small to large",
        "Flexible production for small-quantity, multi-variety orders",
      ],
      description: "An industrial diaphragm custom-made from customer drawings or samples. We offer various materials and hardness options including NBR, EPDM, FKM, and VMQ to supply products optimized for each application. Available in a wide range of sizes from small precision diaphragms to large industrial versions, with a flexible production system for small-quantity, multi-variety orders.",
      image: "https://public.readdy.ai/ai/img_res/edited_c5d69c3e49fd1eab2a364af12460f30c_d7b8a5a5.jpg",
      drawingAvailable: true,
    },
    {
      id: "food-grade-silicone-009",
      name: "Food Processing Products",
      category: "Rubber Molded Products",
      subcategory: "Silicone Products",
      application: "Food processing · Pharmaceutical equipment · Dairy · Beverage",
      material: "VMQ (Silicone) FDA Grade",
      hardness: "50 ~ 70 Shore A",
      tempRange: "-60℃ ~ +230℃",
      features: [
        "FDA and food hygiene regulation compliant materials",
        "Odorless, non-toxic, safe for direct food contact",
        "Maintains elasticity through high-temperature sterilization (CIP/SIP)",
        "Transparent, translucent, and colored custom molding",
      ],
      description: "High-purity silicone rubber products specialized for food and pharmaceutical processes. FDA-grade silicone allows safe use in direct food contact environments, with excellent durability through high-temperature sterilization. Supplied as sealing rings, gaskets, and packing in transparent, translucent, and colored options, useful for process identification.",
      image: "https://public.readdy.ai/ai/img_res/edited_13262d299019c08eabc0a634b928ca8c_51648965.jpg",
      drawingAvailable: true,
    },
    {
      id: "suction-cups-010",
      name: "Suction Cups",
      category: "Rubber Molded Products",
      subcategory: "Silicone Products",
      application: "Logistics automation · Packaging machines · Semiconductor transfer · Vacuum equipment",
      material: "VMQ (Silicone), NBR",
      hardness: "40 ~ 60 Shore A",
      tempRange: "-50℃ ~ +200℃",
      features: [
        "Stable object transfer with excellent vacuum retention",
        "Soft-touch design without damaging work piece surfaces",
        "Maintains shape through repeated use with excellent abrasion resistance",
        "Flat, bellows, and custom shapes available",
      ],
      description: "Highly elastic silicone and NBR suction cups used in logistics automation, packaging machines, and semiconductor transfer. With excellent vacuum retention and a soft contact surface, they stably transfer objects of various shapes while maintaining their shape over long-term repeated use. Available in flat, bellows, and custom shapes.",
      image: "https://public.readdy.ai/ai/img_res/edited_b6fae09c1233c8bd44a39faaaf53f4db_75f543e6.jpg",
      drawingAvailable: true,
    },
  ],
  page: {
    title: "Products",
    subtitle: "High-quality rubber products built on 50 years of technology — 7 categories, customized solutions",
    searchPlaceholder: "Search by product, application, or material",
    total: "{{count}} products",
    empty: "No search results found.",
    reset: "Reset Filters",
    detail: "View Details",
  },
  detail: {
    notFoundTitle: "Product Not Found",
    notFoundDesc: "The requested product information does not exist.",
    backToList: "Back to Products",
    quoteInquiry: "Request a Quote",
    breadcrumbProducts: "Products",
    specsTitle: "Technical Specifications",
    specApplication: "Application",
    specMaterial: "Material",
    specHardness: "Hardness",
    specTempRange: "Operating Temperature",
    specProduction: "Production Method",
    specProductionValue: "Compression Molding",
    specMOQ: "Minimum Order",
    specMOQValue: "Negotiable (small quantities available)",
    featuresTitle: "Key Features",
    drawingNotice: "Drawings and technical data are available for download. Attaching a drawing with your quote request enables more accurate pricing.",
    quoteRequest: "Request a Quote",
    phoneConsult: "Phone Consultation",
    productList: "Product List",
    techData: "View Technical Data",
    inquiry: "Contact Us",
  },
};